const devawsmobile = {
    Auth: {
        identityPoolId: 'us-west-2:485148c1-677b-4e81-be5b-b1ae861fe52b',
        region: 'us-west-2',
    },
    AWSPinpoint: {
        appId: 'a17abcb212914a4580f45baf512003f5',
        region: 'us-west-2',
        endpoint: { attributes: {}, demographic: {} },
    },
};
const prodawsmobile = {
    Auth: {
        identityPoolId: 'us-east-1:6673096a-05e3-4ad5-8bf6-393d93603824',
        region: 'us-east-1',
    },
    AWSPinpoint: {
        appId: '7d708363fd0747e7b66f095c4abd4207',
        region: 'us-east-1',
        endpoint: { attributes: {}, demographic: {} },
    },
};
/* eslint "import/prefer-default-export": "off" */
export const awsmobile = __DEV__
    ? devawsmobile
    : prodawsmobile;
//# sourceMappingURL=awsmobileconfig.js.map